const STEPS = [
  { n: 1, t: "Request", d: "Schedule online or call dispatch with trip details." },
  { n: 2, t: "Confirm", d: "We verify time, mobility needs, and pricing/coverage." },
  { n: 3, t: "Ride", d: "Driver assists from door to vehicle and destination." },
  { n: 4, t: "Return", d: "Round-trip return or on-demand pickup available." },
];

export default function HowItWorks() {
  return (
    <section className="bg-light py-5 border-top border-bottom">
      <div className="container">
        <h2 className="fw-bold h3 mb-3">How it works</h2>
        <div className="row g-4">
          {STEPS.map((s) => (
            <div className="col-12 col-md-6 col-lg-3" key={s.n}>
              <div className="card h-100">
                <div className="card-body">
                  <div className="badge bg-primary">{s.n}</div>
                  <h6 className="mt-2">{s.t}</h6>
                  <p className="text-secondary small mb-0">{s.d}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
